let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6G6jL")).then(() => parcelRequire('dILzZ'));